import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {ILookup} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

type PublishedOutputToolsResponse = ILookup<number>[] | {data?: ILookup<number>[]};

export const fetchPublishedOutputToolsThunk: any = createAsyncThunk<ILookup<number>[]>(
  `${prefix} fetchPublishedOutputTools`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getPublishedOutputTools();
      const body = parsedBody as PublishedOutputToolsResponse;

      if (Array.isArray(body)) {
        return body;
      }

      // Some PAM endpoints wrap collections in { data: [...] }.
      return Array.isArray(body?.data) ? body.data : [];
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch published output tools. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
